import { SendOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Spacing, SpacingUnit } from 'components/ui';
import { TableCellActivityEntity } from 'entities/TableCellActivity';

import { CommentComponentsCommonProps } from '../types';

import { ActivityRenderer } from './ActivityRenderer';
import s from './Content.module.scss';

export const TEXT_MAX_LENGTH = 300;

const Content: React.FC<CommentComponentsCommonProps> = ({ commentsStore }) => {
  const { t } = useTranslation();
  const handleDeleteEntity = React.useCallback(
    (entity: TableCellActivityEntity) => {
      commentsStore.handleDeleteActivity(entity);
    },
    [commentsStore]
  );

  const handleEditEntity = React.useCallback(
    (entity: TableCellActivityEntity) => {
      commentsStore.handleEditActivity(entity);
    },
    [commentsStore]
  );

  const handleSubmit = React.useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      await commentsStore.handleSaveText();
    },
    [commentsStore]
  );

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      commentsStore.textModel.setValue(e.currentTarget.value);
    },
    [commentsStore.textModel]
  );

  return (
    <div className={s.content}>
      {!commentsStore.fetching && (
        <div className={s.content__activities}>
          <Spacing spacing={SpacingUnit.unit3}>
            {commentsStore.activities.map((item) => (
              <ActivityRenderer
                onDelete={handleDeleteEntity}
                onEdit={handleEditEntity}
                entity={item}
                key={item.id}
              />
            ))}
          </Spacing>
        </div>
      )}

      {commentsStore.fetching && (
        <div className={s.content__loadingContainer}>
          <Spin />
        </div>
      )}

      <Divider className={s.content__divider} />
      <form className={s.content__comment} onSubmit={handleSubmit} action="">
        <Input.TextArea
          maxLength={TEXT_MAX_LENGTH}
          placeholder={t('comments.placeholder') as string}
          onChange={handleChange}
          value={commentsStore.textModel.value}
          showCount
          className={s.content__commentField}
        />
        <Button
          disabled={commentsStore.saveCommentButtonDisabled}
          size="large"
          icon={<SendOutlined />}
          htmlType="submit"
          className={s.content__commentButton}
        />
      </form>
    </div>
  );
};

export default observer(Content);
